<template>
  <h-table
    :data="data"
    row-key="label"
    :columns="columns"
    :filter="filter"
    :pagination.sync="serverPagination"
    :rows-per-page-options="perPageOptions"
    :loading="loading"
    ref="table"
    @request="fetchData"
  >
    <q-td
      slot="body-cell-del"
      class="text-right"
      slot-scope="props"
    >
      <q-btn
        @click="editTag(props.row)" 
        icon="edit"
        color="tertiary"
        class="hover-primary"
        flat
        round
      />
      <q-btn
        @click="deleteTag(props.row)"
        icon="delete"
        color="tertiary"
        class="hover-negative"
        flat
        round
      />
    </q-td>
  </h-table>
</template>

<script>
  import {
    HTable,
    HTh
  } from '@';

  import columns from './mixins/columns';
  import api from 'mixins/api';
  import tableHelpers from '@/HTable/helpers';

  import {
    QTable,
    QTr,
    QTh,
    QTd,
    QField,
    QInput,
    QCheckbox,
    QSelect,
    QSlider,
    QBtn,
    QIcon,
    QTooltip,
    QPopover
  } from 'quasar';

  export default {
    name: 'TagsList',
    components: {
      QTable,
      QTr,
      QTh,
      QTd,
      QField,
      QInput,
      QCheckbox,
      QSelect,
      QSlider,
      QBtn,
      QIcon,
      QTooltip,
      QPopover,
      HTable,
      HTh
    },
    mixins: [
      tableHelpers,
      columns,
      api
    ],
    data () {
      return {};
    },
    mounted () {
      this.updateTags();
    },
    methods: {
      updateTags () {
        this.fetchData({
          pagination: this.serverPagination,
          filter: this.filter
        });
      },
      fetchData ({pagination, filter}) {
        this.query = this.getQuery(pagination, filter);
        this.loading = true;
        this.api.get(`tags/${this.query}`).then(response => {
          if (this.verifyResponse(response)) {
            this.updatePagination(pagination, response.data.length);
            this.updateData(response.data);
            this.$store.commit('tagsList/setData', response.data);
          }
          this.loading = false;
        }).catch(error => {
          console.error(error);
          this.loading = false;
        });
      },
      editTag (row) {
        this.$q.dialog({
          title: 'Редактировать тег',
          color: 'primary',
          ok: true,
          cancel: true,
          prompt: {
            model: row.name,
            type: 'text'
          }
        }).then(data => {
          this.$http.put(`api/v1.0/tags/${row.id}`, {
            'name': data
          }).then((response) => {
            this.updateTags();
          }).catch(error => {

          });
        });
      },
      deleteTag (row) {
        this.$q.dialog({
          title: 'Удалить тег?',
          color: 'primary',
          ok: true,
          cancel: true
        }).then(data => {
          this.$http.delete(`api/v1.0/tags/${row.id}`).then((response) => {
            this.updateTags();
          }).catch(error => {

          });
        });
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TagsList/TagsList.vue